export var WebhookType;
(function (WebhookType) {
    WebhookType[WebhookType["TICKET_CREATED"] = 1] = "TICKET_CREATED";
    WebhookType[WebhookType["USER_REPLY_CREATED"] = 2] = "USER_REPLY_CREATED";
    WebhookType[WebhookType["INTERNAL_REPLY_CREATED"] = 3] = "INTERNAL_REPLY_CREATED";
    WebhookType[WebhookType["SSO_USER_OUTDATED"] = 4] = "SSO_USER_OUTDATED";
    WebhookType[WebhookType["TICKET_TRANSFERRED"] = 5] = "TICKET_TRANSFERRED";
    WebhookType[WebhookType["CHAT_ENDED"] = 6] = "CHAT_ENDED";
    WebhookType[WebhookType["CALL_ENDED"] = 7] = "CALL_ENDED";
    WebhookType[WebhookType["TICKET_STATUS_CLOSED_OR_SOLVED"] = 8] = "TICKET_STATUS_CLOSED_OR_SOLVED";
    WebhookType[WebhookType["USER_EVENT"] = 9] = "USER_EVENT";
    WebhookType[WebhookType["ARTICLE_SENT_TO_TRANSLATION"] = 10] = "ARTICLE_SENT_TO_TRANSLATION";
    WebhookType[WebhookType["CSAT_SUBMITTED"] = 14] = "CSAT_SUBMITTED";
    WebhookType[WebhookType["AGENT_REPLY_CREATED"] = 15] = "AGENT_REPLY_CREATED";
    WebhookType[WebhookType["TICKET_STATUS_CHANGED"] = 16] = "TICKET_STATUS_CHANGED";
    WebhookType[WebhookType["TICKET_BRAND_CHANGED"] = 17] = "TICKET_BRAND_CHANGED";
    WebhookType[WebhookType["AGENT_JOINED_CHAT"] = 20] = "AGENT_JOINED_CHAT";
    WebhookType[WebhookType["AGENT_LEFT_CHAT"] = 21] = "AGENT_LEFT_CHAT";
    WebhookType[WebhookType["AGENT_REPLIED_ON_CHAT"] = 22] = "AGENT_REPLIED_ON_CHAT";
})(WebhookType || (WebhookType = {}));
//# sourceMappingURL=webhook-type.enum.js.map